import EA from 'helpers/init';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.processAnim = ($this) => {
    const links = [...$this.querySelectorAll('.process-link')];
    const nums = [...$this.querySelectorAll('.process-num')];
    const imgs = [...$this.querySelectorAll('.process-img-inner')];
    const mq = window.matchMedia('(min-width: 1201px)');

    // let st;
    let activeIndex = 0;

    const setActive = (index) => {
        const i = Math.max(0, Math.min(index, links.length - 1));

        links.forEach((el, idx) => el.classList.toggle('active', idx === i));
        nums.forEach((el, idx) => el.classList.toggle('active', idx === i));
        imgs.forEach((el, idx) => el.classList.toggle('active', idx === i));

        activeIndex = i;
    };

    // const initScroll = () => {
    //     if (!mq.matches || !links.length) return;

    //     st = ScrollTrigger.create({
    //         trigger: $this,
    //         start: 'top top',
    //         end: () => `+=${window.innerHeight * 0.45 * (links.length - 1)}`,
    //         pin: true,
    //         pinSpacing: true,
    //         scrub: 0.5,
    //         anticipatePin: 1,
    //         snap: {
    //             snapTo: 1 / (links.length - 1),
    //             duration: { min: 0.1, max: 0.25 },
    //             delay: 0.02,
    //             ease: 'power1.inOut'
    //         },
    //         onUpdate: (self) => {
    //             const nextIndex = Math.round(self.progress * (links.length - 1));
    //             if (nextIndex !== activeIndex) setActive(nextIndex);
    //         }
    //     });
    // };

    links.forEach((link, index) => {
        link.addEventListener('mouseenter', () => {
            if (mq.matches) setActive(index);
        });
    });

    setActive(0);
    // initScroll();

    // const onResize = () => {
    //     if (st) {
    //         st.kill();
    //         st = null;
    //     }
    //     ScrollTrigger.refresh();
    //     initScroll();
    // };

    // window.addEventListener('resize', onResize);

    // return () => {
    //     if (st) st.kill();
    //     window.removeEventListener('resize', onResize);
    // };
};
